import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const poissonDescription: CalculatorDescription = {
  id: CalculatorId.POISSON_DISTRIBUTION,
  title: 'Poisson Distribution Calculator',
  metaTitle: 'Online Poisson Distribution Calculator - Probability Tool',
  description: 'Calculate probabilities for events occurring in a fixed interval using the Poisson distribution. Perfect for analyzing rare events and counting processes.',
  metaDescription: 'Calculate Poisson probabilities online. Analyze event occurrences with our free probability calculator. Perfect for statistical analysis of rare events.',
  howTo: {
    title: 'How to Use Poisson Calculator',
    steps: [
      'Enter lambda (average rate of events)',
      'Specify number of events',
      'View probability results and distribution'
    ]
  },
  examples: [
    {
      title: 'Call Center Analysis',
      description: 'Analyzing number of incoming calls per hour',
      dataDescription: 'Event count data with known average rate',
      insights: [
        'Shows probability of specific call volumes',
        'Calculates cumulative probabilities',
        'Helps predict staffing needs',
        'Models random events occurring at a constant rate'
      ]
    },
    {
      title: 'Website Traffic',
      description: 'Analyzing number of visitors per minute',
      dataDescription: 'Count data of website visits',
      insights: [
        'Shows probability of traffic patterns',
        'Calculates likelihood of traffic spikes',
        'Helps with server capacity planning',
        'Models random arrivals over fixed time intervals'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BINOMIAL_DISTRIBUTION,
    CalculatorId.NORMAL_DISTRIBUTION
  ]
}; 